<template>
<div class="wrap">
<div class="logo"><img src="../../assets/header.png" alt=""></div>
<div class="logo1">国家市场监督管理总局专业技术人才开发中心<br>在线报名及发证管理系统</div>
</div>
  
</template>

<script>
export default {

}
</script>

<style lang="less">
.logo{
   background-color: #fff;
   /* height: 119px; */
   img{
      width: 100%;
   }
}
.logo1{
   display: none;
}
@media  screen and(max-width:768px) {
.logo1{
   display: block;
   background: #3584E8;
   color: #fff;
   font-weight: 700;
   font-size: 18px;
   padding:15px 0;
}
.logo{
   display: none;
}
}
</style>